import type { FilterStates, FilterStatesKey } from '../type/filter-state';

const getAppliedFilterCount = (
    filterStates: FilterStates,
    filterKey: FilterStatesKey
): number => {
    const filter = filterStates[filterKey];
    if (
        !filter ||
        typeof filter === 'number' ||
        typeof filter === 'string' ||
        Array.isArray(filter)
    )
        return 0;
    switch (filter.kind) {
        case 'CategorySelector':
            return 0;
        case 'RangeSelector':
            return filter.value ? 1 : 0;
        case 'CheckboxGroup':
            return filter.checkedItems?.length ?? 0;
        case 'AwardsFilter':
            return filter.checkedItems?.length ?? 0;
        case 'SearchList':
            return filter.selectedItems?.length ?? 0;
        case 'Checkbox':
            return filter.checked ? 1 : 0;
        case 'RadioGroup':
            return filter.selectedItem && !filter.selectedItem.isDefault
                ? 1
                : 0;
        case 'Location':
            return filter.selectedLocation ? 1 : 0;
        default:
            throw new Error(
                `[filter-state-util] getAppliedFilterCount: unsupported filter kind: ${filter}`
            );
    }
};

export const hasAppliedFilter = (
    filterStates: FilterStates,
    filterKeys: FilterStatesKey[]
): boolean => {
    return filterKeys.some(
        (filterKey) => getAppliedFilterCount(filterStates, filterKey) > 0
    );
};

export const getAppliedFilterNumber = (
    filterStates: FilterStates,
    ignoreFilterKeys?: FilterStatesKey[]
): number => {
    return Object.keys(filterStates).reduce((num, filterKey) => {
        if (
            ignoreFilterKeys &&
            ignoreFilterKeys.includes(filterKey as FilterStatesKey)
        )
            return num;
        num += getAppliedFilterCount(
            filterStates,
            filterKey as FilterStatesKey
        );
        return num;
    }, 0);
};
